module.exports = __webpack_public_path__ + "img/emo_39.411dcb1b.png";